import { Box, Card, List, ListItem, ListItemText, Stack, Typography } from '@ethings/ui-toolkit';
import { Theme, useTheme } from '@mui/material';
import { FC } from 'react';
import { EventDefinition } from '../../../../notable-events';
import { Undefinable } from '../../../../types';
import { getEventLabelWithFlag, getFeatureLabelWithFlag } from '../../../../util';
import { getEventDictionary, useNotableEventsContext } from '../../../entity-journey';
import { CircleIcon } from '../../../icons';
import { EventLocationData } from '../../thing-event-pane';

interface Props {
  data: EventLocationData[];
}

interface EventGroupDetail {
  featureLabel: string;
  eventLabel: string;
  count: number;
  definition: Undefinable<EventDefinition>;
}

const groupEventData = (data: EventLocationData[], theme: Theme, notableEvents: EventDefinition[]): Record<string, EventGroupDetail> => {
  const eventGrouping: Record<string, EventGroupDetail> = {};

  data.map((event, _) => {
    const id = `${event.featureTypeId}-${event.eventTypeId}`;
    if (!eventGrouping[id]) {
      eventGrouping[id] = {
        featureLabel: getFeatureLabelWithFlag(event.feature),
        eventLabel: getEventLabelWithFlag(event.featureTypeId, event.eventTypeId, event.feature),
        count: 1,
        definition: getEventDictionary(event, theme, notableEvents),
      };
    } else {
      eventGrouping[id].count += 1;
    }
  });

  return eventGrouping;
};

export const ClusterSummary: FC<Props> = ({ data }) => {
  const theme = useTheme();
  const { notableEvents } = useNotableEventsContext();
  const eventDataGrouped = groupEventData(data, theme, notableEvents);

  return <Card elevation={0}>
    <Box py={1} minWidth={350}>
      <List disablePadding>
        {eventDataGrouped && Object.entries(eventDataGrouped).map(([key, group]) => (
          <ListItem key={key}>
            <ListItemText>
              <Stack direction='row' alignItems='center' spacing={2}>
                <Box lineHeight={0} mr={1}><CircleIcon style={{ fontSize: '1rem', color: group.definition?.styling.backgroundColor }} /></Box>
                <Typography variant='body2' component='div' width='40%' overflow='hidden' textOverflow='ellipsis'>{group.eventLabel}</Typography>
                <Typography variant='body2' component='div' color='textSecondary' width='30%'>{group.featureLabel}</Typography>
                <Typography variant='body2' component='div' textAlign='right' flexGrow={1} >{group.count}</Typography>
              </Stack>
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Box>
  </Card>;
};
